import React from "react";
import { useApp } from "../context/AppContext";

const Star = () => <span className="text-orange mx-4 text-lg">✦</span>;

const Marquee = () => {
  const { t } = useApp();
  const items = t("marquee");
  const row = [...items, ...items, ...items];
  return (
    <div className="bg-navy py-4 overflow-hidden">
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="inline-flex items-center font-display font-semibold text-white/90 text-sm md:text-base">
            {item} <Star />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
